import * as React from 'react';
import Map from 'ol/Map';
import {LayerBase} from "webmapsjs/dist/layers";
import Event from 'ol/events/Event';

//
// React.StyleSheet.create({
//     text: {
//         position: 'absolute',
//         top: 0,
//         left: 0
//     } as React.TextStyle // cast to existing interface
// });


export default class Swiper extends React.Component<{
    map: Map, leftComponent, rightComponent,
    leftLayers: LayerBase[], rightLayers: LayerBase[], allLayers: LayerBase[]
}, {
    left: string;
    dragging: boolean, percentRight: number, offset: number
}> {

    tim: number;
    leftLayerRef: LayerBase[];
    rightLayerRef: LayerBase[];

    preCompLeft: (e) => any;
    preCompRight: (e) => any;
    postComp: (e) => any;
    layerCache: LayerBase[];


    constructor(c, p) {
        super(c, p);
        this.state = {left: '50%', dragging: false, percentRight: 50, offset: null};
        this.leftLayerRef = [];
        this.rightLayerRef = [];

        this.preCompLeft = (e) => {
            this._precompLeft(e);
        };

        this.preCompRight = (e) => {
            this._precompRight(e);
        };

        this.postComp = (e) => {
            this._postComp(e);
        };

        this.layerCache = []
    }

    get allLayers(): LayerBase[] {

        let retLayers: LayerBase[] = [];

        for (let l of this.leftLayerRef) {
            retLayers.push(l);
        }

        for (let l of this.rightLayerRef) {
            if (retLayers.indexOf(l) === -1) {
                retLayers.push(l);
            }
        }

        return retLayers;
    }

    removeAllLayers() {
        for (let l of this.leftLayerRef) {
            l.olLayer.un('precompose', this.preCompLeft);
            l.olLayer.un('precompose', this.preCompRight);
            l.olLayer.un('postcompose', this.postComp);
            l.visible = false;
            // this.props.map.removeLayer(l.olLayer);
        }

        for (let l of this.rightLayerRef) {
            l.olLayer.un('precompose', this.preCompLeft);
            l.olLayer.un('precompose', this.preCompRight);
            l.olLayer.un('postcompose', this.postComp);
            l.visible = false;
            // this.props.map.removeLayer(l.olLayer);
        }

    }


    componentDidUpdate(prevProps: Readonly<{ map: Map; leftComponent; rightComponent; leftLayers: LayerBase[]; rightLayers: LayerBase[] }>, prevState: Readonly<{ left: string; dragging: boolean; percentRight: number; offset: number }>, snapshot?: any): void {


        // console.log(newLayerMatch);
        //
        // for (let m of [this.props.leftLayers, this.props.rightLayers, prevProps.leftLayers, prevProps.rightLayers]){
        //     for (let l of m){
        //         if (this.layerCache.indexOf(l) < 0){
        //             this.layerCache.push(l);
        //         }
        //     }
        // }
        //
        //
        //
        let leftMatch = true;
        let rightMatch = true;
        //

        if (this.props.leftLayers.length !== this.leftLayerRef.length) {
            leftMatch = false;
        }

        for (let l of this.props.leftLayers) {
            if (this.leftLayerRef.indexOf(l) < 0) {
                leftMatch = false;
                break;
            }
        }

        if (this.props.rightLayers.length !== this.rightLayerRef.length) {
            rightMatch = false;
        }

        for (let l of this.props.rightLayers) {
            if (this.rightLayerRef.indexOf(l) < 0) {
                rightMatch = false;
                break;
            }
        }

        if (leftMatch && rightMatch) {
            //pass
        } else {
            this.removeAllLayers();

            this.leftLayerRef = this.props.leftLayers;
            this.rightLayerRef = this.props.rightLayers;

            if (this.props.leftLayers === this.props.rightLayers) {
                for (let l of this.props.leftLayers) {
                    l.visible = true;

                }
            } else {
                for (let l of this.props.leftLayers) {
                    l.olLayer.on('precompose', this.preCompLeft);
                    l.olLayer.on('postcompose', this.postComp);
                    l.visible = true;
                }

                for (let l of this.props.rightLayers) {
                    l.olLayer.on('precompose', this.preCompRight);
                    l.olLayer.on('postcompose', this.postComp);
                    l.visible = true;
                }
            }
        }


    }

    _precompLeft(event: Event) {
        let ctx = event['context'] as CanvasRenderingContext2D;
        let width = ctx.canvas.width * (this.state.percentRight / 100);

        ctx.save();
        ctx.beginPath();
        ctx.rect(0, 0, width, ctx.canvas.height);
        ctx.clip();
    }

    _precompRight(event: Event) {
        let ctx = event['context'] as CanvasRenderingContext2D;
        let width = ctx.canvas.width * (this.state.percentRight / 100);

        ctx.save();
        ctx.beginPath();
        ctx.rect(width, 0, ctx.canvas.width - width, ctx.canvas.height);
        ctx.clip();
    }


    _postComp(event: Event) {
        let ctx = event['context'] as CanvasRenderingContext2D;
        ctx.restore();
    }

    componentDidMount(): void {

        window.onmouseup = (e) => {
            this.setState({dragging: false});
        };


        setTimeout(() => {
            (this.props.map.getTargetElement() as HTMLDivElement).onmousemove = (evt) => {

                if (evt.target['id'] == 'swiper' || (evt.target['tagName'] as string).toLowerCase() == 'canvas') {
                    //pass
                } else {
                    return;
                }

                if (this.state.dragging) {
                    let mapLeft = this.props.map.getTargetElement().clientLeft;
                    let mapWidth = this.props.map.getTargetElement().clientWidth;


                    let pRight = 100 * (evt.clientX - mapLeft) / mapWidth;

                    if (pRight < 5 || pRight > 95) {
                        return
                    }

                    this.setState({percentRight: pRight});
                    this.props.map.renderSync();
                }
            }
        }, 100)
    }

    render() {

        let divStyle = {
            left: `${this.state.percentRight.toFixed(2)}%`,
            position: 'absolute' as 'absolute',
            top: 0,
            width: '9px',
            height: '100%',
            borderLeft: 'solid #000 1px',
            borderRight: 'solid #000 1px',
            backgroundColor: '#d3d3d3',
            zIndex: 10,
            cursor: 'ew-resize'
        };

        return <div id="swiper" style={divStyle}

                    onDrag={(e) => {
                        console.log(e);
                    }
                    } onMouseDown={(e) => {
            this.setState({dragging: true});
            this.setState({offset: e.clientX})
        }

        }>
            {this.props.leftComponent}
            {this.props.rightComponent}
        </div>

    }


}
